var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/ban-types */
import { ChildProperty, Property, Complex, Collection } from '@syncfusion/ej2-base';
import { Theme } from '../../common/model/theme';
import { Font, Border } from '../../common/model/base';
/**
 * Configures the Annotation for chart.
 */
export class ChartAnnotationSettings extends ChildProperty {
}
__decorate([
    Property('0')
], ChartAnnotationSettings.prototype, "x", void 0);
__decorate([
    Property('0')
], ChartAnnotationSettings.prototype, "y", void 0);
__decorate([
    Property(null)
], ChartAnnotationSettings.prototype, "content", void 0);
__decorate([
    Property('Center')
], ChartAnnotationSettings.prototype, "horizontalAlignment", void 0);
__decorate([
    Property('Pixel')
], ChartAnnotationSettings.prototype, "coordinateUnits", void 0);
__decorate([
    Property('Chart')
], ChartAnnotationSettings.prototype, "region", void 0);
__decorate([
    Property('Middle')
], ChartAnnotationSettings.prototype, "verticalAlignment", void 0);
__decorate([
    Property(null)
], ChartAnnotationSettings.prototype, "xAxisName", void 0);
__decorate([
    Property(null)
], ChartAnnotationSettings.prototype, "yAxisName", void 0);
__decorate([
    Property(null)
], ChartAnnotationSettings.prototype, "description", void 0);
/**
 * label border properties.
 */
export class LabelBorder extends ChildProperty {
}
__decorate([
    Property('')
], LabelBorder.prototype, "color", void 0);
__decorate([
    Property(1)
], LabelBorder.prototype, "width", void 0);
__decorate([
    Property('Rectangle')
], LabelBorder.prototype, "type", void 0);
/**
 * categories for multi level labels
 */
export class MultiLevelCategories extends ChildProperty {
}
__decorate([
    Property(null)
], MultiLevelCategories.prototype, "start", void 0);
__decorate([
    Property(null)
], MultiLevelCategories.prototype, "end", void 0);
__decorate([
    Property('')
], MultiLevelCategories.prototype, "text", void 0);
__decorate([
    Property(null)
], MultiLevelCategories.prototype, "maximumTextWidth", void 0);
__decorate([
    Property(null)
], MultiLevelCategories.prototype, "customAttributes", void 0);
__decorate([
    Property('')
], MultiLevelCategories.prototype, "type", void 0);
/**
 * Strip line properties
 */
export class StripLineSettings extends ChildProperty {
}
__decorate([
    Property(true)
], StripLineSettings.prototype, "visible", void 0);
__decorate([
    Property(false)
], StripLineSettings.prototype, "startFromAxis", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "start", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "end", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "size", void 0);
__decorate([
    Property('#808080')
], StripLineSettings.prototype, "color", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "dashArray", void 0);
__decorate([
    Property('Auto')
], StripLineSettings.prototype, "sizeType", void 0);
__decorate([
    Property(false)
], StripLineSettings.prototype, "isRepeat", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "repeatEvery", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "repeatUntil", void 0);
__decorate([
    Property(false)
], StripLineSettings.prototype, "isSegmented", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "segmentStart", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "segmentEnd", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "segmentAxisName", void 0);
__decorate([
    Complex({ color: 'transparent', width: 1 }, Border)
], StripLineSettings.prototype, "border", void 0);
__decorate([
    Property('')
], StripLineSettings.prototype, "text", void 0);
__decorate([
    Property(null)
], StripLineSettings.prototype, "rotation", void 0);
__decorate([
    Property('Middle')
], StripLineSettings.prototype, "horizontalAlignment", void 0);
__decorate([
    Property('Middle')
], StripLineSettings.prototype, "verticalAlignment", void 0);
__decorate([
    Complex(Theme.stripLineLabelFont, Font)
], StripLineSettings.prototype, "textStyle", void 0);
__decorate([
    Property('Behind')
], StripLineSettings.prototype, "zIndex", void 0);
__decorate([
    Property(1)
], StripLineSettings.prototype, "opacity", void 0);
/**
 * MultiLevelLabels properties
 */
export class MultiLevelLabels extends ChildProperty {
}
__decorate([
    Property('Center')
], MultiLevelLabels.prototype, "alignment", void 0);
__decorate([
    Property('Wrap')
], MultiLevelLabels.prototype, "overflow", void 0);
__decorate([
    Complex(Theme.axisLabelFont, Font)
], MultiLevelLabels.prototype, "textStyle", void 0);
__decorate([
    Complex({ color: null, width: 1, type: 'Rectangle' }, LabelBorder)
], MultiLevelLabels.prototype, "border", void 0);
__decorate([
    Collection([], MultiLevelCategories)
], MultiLevelLabels.prototype, "categories", void 0);
/**
 * Specifies range for scrollbarSettings property
 *
 * @public
 */
export class ScrollbarSettingsRange extends ChildProperty {
}
__decorate([
    Property(null)
], ScrollbarSettingsRange.prototype, "minimum", void 0);
__decorate([
    Property(null)
], ScrollbarSettingsRange.prototype, "maximum", void 0);
/**
 * Scrollbar Settings Properties for Lazy Loading
 */
export class ScrollbarSettings extends ChildProperty {
}
__decorate([
    Property(false)
], ScrollbarSettings.prototype, "enable", void 0);
__decorate([
    Property(null)
], ScrollbarSettings.prototype, "pointsLength", void 0);
__decorate([
    Complex({}, ScrollbarSettingsRange)
], ScrollbarSettings.prototype, "range", void 0);
